module.exports = __webpack_public_path__ + "static/media/shopifyicon.420a7c69.svg";